import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../theme/Component/Modal';
import { BasicTable, MASK_NUMBER } from '../../../../../theme/Component/BasicTable';
import { _MaterialAvailableProductionOrder, _MaterialAvailableProductionSelect } from '../../../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number;
    onChange: any;
    idProductionOrder: any,
    year: any,
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const MaterialAvailableProductionSelect = ({ idSelector, onChange, label, returnType = "ID", render, idProductionOrder, year }: Props) => {

    const { instance, lista, setLista } = useDataBean(_MaterialAvailableProductionSelect)
    const [id, setID] = useState(null);

    const modal = useModal("Producto", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [idProductionOrder, year])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDProduct == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    //HEY BUSCA LA X CAMBIA LA PROPIEDAD CRACK

    const getLista = () => {

        instance.getRawMaterialAvailableProductionOrderCatalog(idProductionOrder, year).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((item) => {
                        item.DataBeanProperties.UnitName = (item.DataBeanProperties.MeasurementUnitCode ?? "") + "-" + (item.DataBeanProperties.MeasurementUnitName ?? "");

                    });
                    setLista(x)
                }

            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDProduct', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'UnitName', visible: true },
        { title: 'Cantidad', property: 'TotalQuantity', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Producto"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDProduct); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}